module.exports = __webpack_public_path__ + "static/media/London-night.d276493e.svg";